import axiosInstance from "../../../../global/helpers/axiosInstance";
import { GET_TRAER_VIDEOS, GET_TRAER_VIDEOS_FAIL, GET_TRAER_VIDEOS_LIMPIAR, GET_TRAER_VIDEOS_SUCCESS } from "../../ActionTypes";


export const wsGetTraerVideos = ()=> (dispatch) => {
    dispatch({type: GET_TRAER_VIDEOS})

   axiosInstance().then(respuesta => {
    respuesta
    .get('Texto/getvideotutoriales')
    .then((resp)=> {
        dispatch({type: GET_TRAER_VIDEOS_SUCCESS, payload: resp})
    })
    .catch ((err) => {
        dispatch({type: GET_TRAER_VIDEOS_FAIL, payload: err})

    })
   } )

}


export const limpiarTraerVideos = () => (dispatch) => {
    dispatch({type: GET_TRAER_VIDEOS_LIMPIAR});
}